module.exports = __webpack_public_path__ + "static/media/forms@2x.16c5ae7e.jpg";